import { cva } from "class-variance-authority";

/**
 * Shared sizing + radius for text-style inputs.
 *
 * Sizes
 * - `sm`  → h-8  rounded-md text-[12px]   (compact toolbar fields)
 * - `md`  → h-9  rounded-lg text-sm       (default — settings, builder)
 * - `lg`  → h-11 rounded-xl text-[13.5px] (auth, hero forms, marketing)
 *
 * Radius is paired with size so the field always looks intentional;
 * override via `className` only when a specific design demands it.
 */
export const inputVariants = cva(
  "flex w-full bg-transparent ring-0 ring-offset-transparent transition-colors placeholder:opacity-80 hover:bg-secondary/20 focus:bg-secondary/20 focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        sm: "h-8 rounded-md px-2.5 py-0.5 text-[12px]",
        md: "h-9 rounded-lg px-3 py-0.5 text-sm",
        lg: "h-11 rounded-xl px-3.5 py-0.5 text-[13.5px]",
      },
      hasError: {
        true: "border border-error focus:border-error",
        false: "border border-border focus:border-primary",
      },
    },
    defaultVariants: {
      size: "md",
      hasError: false,
    },
  },
);
